import { useEffect, useLayoutEffect, useRef } from "react";

// 360/370: panel detailu vedle tabulky (Úkoly, Doklady) — přilepený k oknu a vysoký přes zbytek
// obrazovky. Při otevření vyjede zprava; přepnutí na jiný řádek ho nepohne (zůstává namontovaný),
// zavřením zmizí a tabulka se roztáhne zpět.
export function useFillHeight(ref) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    let raf = 0;
    const fit = () => { raf = 0; const top = el.getBoundingClientRect().top; el.style.height = `${Math.max(360, window.innerHeight - Math.max(top, 24) - 24)}px`; };
    const on = () => { if (!raf) raf = requestAnimationFrame(fit); };
    fit();
    document.addEventListener("scroll", on, { capture: true, passive: true });
    window.addEventListener("resize", on);
    return () => { cancelAnimationFrame(raf); document.removeEventListener("scroll", on, { capture: true }); window.removeEventListener("resize", on); };
  }, [ref]);
}

// Esc zavře panel — ne při psaní a ne nad otevřeným oknem nebo nabídkou (ty zavře Esc samo).
export function useDockEscape(onClose, enabled = true) {
  const ref = useRef(onClose);
  ref.current = onClose;
  useEffect(() => {
    if (!enabled) return undefined;
    const h = (e) => {
      if (e.key !== "Escape" || e.defaultPrevented) return;
      if (document.querySelector('[role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"]')) return;
      const t = e.target, tag = (t?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || t?.isContentEditable) return;
      ref.current();
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [enabled]);
}

export function DetailDock({ label, testid, className = "", children }) {
  const ref = useRef(null);
  useFillHeight(ref);
  return (
    <aside ref={ref} aria-label={label} data-testid={testid}
      className={`sticky top-6 animate-in fade-in slide-in-from-right-8 duration-300 motion-reduce:animate-none ${className}`}>
      {children}
    </aside>
  );
}
